/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../../../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { PrintLabelPageService } from "../../../../../services";

const MODULE_NAME = "printLabel.machines.states.getPresentationLists";
const log: any = LoggerModule?.getInstance();

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.PrintLabelPageService") as PrintLabelPageService;
};

export const getPresentationLists = async (context: any, event: any) => {
  const currentState = "GET_PRESENTATION_LISTS";
  const method = "getPresentationLists";

  return new Promise(async (resolve, reject) => {
    try {
      log.blue(MODULE_NAME, "context: ", context, "event: ", event);

      const srv = getSrv();
      const content = await srv.getPresentationLists();

      if (content) {
        return resolve({
          key: "GET_PRESENTATION_LISTS_SUCCESS",
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = "Get Presentations failed";
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: "GET_PRESENTATION_LISTS_FAILED",
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      return reject({
        key: "GET_PRESENTATION_LISTS_FAILED",
        value: err?.message,
      });
    }
  });
};
